import { FilterViewModel } from './filterViewModel';

export class FilterViewModelWithComment {
  filters: FilterViewModel[];
  comment: string;
}
